import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-duplicate-h1',
    templateUrl: './duplicate-h1.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoDuplicateH1Component {
}
